import React, { useEffect, useState } from 'react';
import { history } from '../_helpers/history';
import { Button } from '@material-ui/core';
import { competitionUserService } from '../_services/competitionUser.service';
import { competitionService } from '../_services/competition.service'; 
import { toastr } from '../_components/toastr';
import { useParams } from 'react-router-dom';

export function TransferButton() {
    const [isLoading, setLoading] = useState(false);
    const [currentUserId, setCurrentUserId] = useState('');
    const [isCurrentUser, setIsCurrentUser] = useState(true);
    const [transferTokens, setTransferTokens] = useState(0);
    const [isRegistrationOpen, setIsRegistrationOpen] = useState(false); 

    const { userId } = useParams<{ userId: string }>();

    useEffect(() => {
        fetchData();
    }, [userId]);

    async function fetchData() {
        try {
            setLoading(true);

            const currentUser = JSON.parse(localStorage.getItem('currentUser') ?? "");
            setCurrentUserId(currentUser.id);

            if (userId !== undefined)
                setIsCurrentUser(currentUser.id === userId);

            const [tokens, registrationOpen] = await Promise.all([
                competitionUserService.getTransferTokens(currentUser.id),
                competitionService.isRegistrationOpen() 
            ]);

            setTransferTokens(tokens);
            setIsRegistrationOpen(registrationOpen);
        }
        catch (e) {
            toastr.error("Something went wrong getting transfer details. Please try again later");
        }
        finally {
            setLoading(false);
        }
    }

    function transferHorse() {
        history.push("/Competition/Transfer/" + currentUserId);
    }

    const isDisabled =
        isLoading ||
        (!isRegistrationOpen && transferTokens === 0); 

    return (
        <>
            {isCurrentUser === true && (
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled={isDisabled}
                    disableElevation
                    onClick={transferHorse}
                >
                    {isRegistrationOpen
                        ? "Edit Horse Entries Until Registration Closes"
                        : "Transfer Horse With Transfer Token"}
                </Button>

            )}
        </>
    );
}
